export const PRODUCT_STORE = 'PRODUCT_STORE';
export const PRODUCT_UPDATE = 'PRODUCT_UPDATE';
export const PRODUCT_DESTROY = 'PRODUCT_DESTROY';
